// FolderCreateService.ts
import axios, { AxiosResponse } from 'axios'
import { UploadRequestResponse } from '../../types'
import { getEncryptionKeys, RequestOptions } from '../request/RequestHelpers'
import { RequestService } from '../request/RequestService'
import { OperationSpec } from '../transactions/models/OperationContext'
import { getParameters } from './FilesService'

export class FolderCreateService {
  onProgressUpdate?: (progress: number) => void
  private abortController: AbortController | null = null

  constructor() {
    this.abortController = new AbortController()
  }

  // Metodo principale per la creazione della cartella
  public async createFolder(
    options: OperationSpec,
    signal?: AbortSignal
  ): Promise<UploadRequestResponse> {
    const { path, isEncryptedZone = false } = options

    // MD5 vuoto per le cartelle
    const emptyMd5 = '1B2M2Y8AsgTpgAmY7PhCfg=='
    let extraRequestOptions: Partial<RequestOptions> | undefined = undefined

    if (isEncryptedZone) {
      const { requestOptions } = await getEncryptionKeys(options)
      extraRequestOptions = requestOptions
    }

    // Richiesta di creazione cartella
    const declaredRequest =
      await RequestService.makeRequest<UploadRequestResponse>(
        options,
        extraRequestOptions,
        signal
      )

    await this.performFolderCreation(declaredRequest, emptyMd5, signal)
    return declaredRequest
  }

  // Esecuzione effettiva della creazione cartella
  private async performFolderCreation(
    uploadRequest: UploadRequestResponse,
    contentMD5: string,
    signal?: AbortSignal
  ): Promise<AxiosResponse> {
    const { upload_url, requestOptions } = uploadRequest
    const parameters = await getParameters()

    const headers: any = {
      accept: '*/*',
      'content-md5': contentMD5,
      'content-type': 'application/octet-stream',
    }

    // Aggiunta headers per zone criptate
    if (requestOptions.encryption_iv) {
      headers[parameters.storage.metadata_prefix + 'encryption-iv'] =
        requestOptions.encryption_iv
    }
    if (requestOptions.encryption_dek) {
      headers[parameters.storage.metadata_prefix + 'encryption-dek'] =
        requestOptions.encryption_dek
    }

    return axios.put(upload_url, null, {
      headers,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total!
        )
        console.log(`Upload progress: ${percentCompleted}%`)
        if (this.onProgressUpdate) {
          this.onProgressUpdate(percentCompleted)
        }
      },
      signal,
    })
  }

  abortOperation(): void {
    if (this.abortController) {
      this.abortController.abort()
    }
  }
}

export default FolderCreateService
